// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import App from './App'
//import { AppRoutes } from './routes/index'
import routes from './routes/index'
import store from './vuex/index'
import 'vue-loading-overlay/dist/vue-loading.css';
import 'animate.css';

import "vue-multiselect/dist/vue-multiselect.min.css";

// todo
// cssVars()

Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)

// BEGIN axios
window.axios = require('axios');
window.axios.headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'X-Requested-With': 'XMLHttpRequest'
};

// Request intercept
window.axios.interceptors.request.use(config => {

    const authToken = store.getters['auth/authToken'];
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
}, err => {
    return Promise.reject(err);
});

// Response intercept
window.axios.interceptors.response.use(response => response,
    error => {

        if (error.response != null &&
            (error.response.status === 401 || error.response.status === 403)) {
            store.dispatch('auth/authLogout')
                .then((result) => {
                    router.push({ name: 'Login' });
                })
                .catch((err) => {
                    showErrorNotification(err);
                });

            return Promise.reject(error);
        }

        if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
            return Promise.reject(error);
        }

        showErrorNotification(error);

        return Promise.reject(error);
    });

// END axios

// BEGIN Notifications

import VueNotifications from 'vue-notifications'

// Include mini-toaster (or any other UI-notification library)
import miniToastr from 'mini-toastr'

// We shall setup types of the messages. ('error' type - red and 'success' - green in mini-toastr)
const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

// This step requires only for mini-toastr, just an initialization
miniToastr.init({ types: toastTypes })

// Here we are seting up messages output to `mini-toastr`
// This mean that in case of 'success' message we will call miniToastr.success(message, title, timeout, cb)
// In case of 'error' we will call miniToastr.error(message, title, timeout, cb)
// and etc.
function toast({ title, message, type, timeout, cb }) {
    return miniToastr[type](message, title, timeout, cb)
}

// Here we map vue-notifications method to function abowe (to mini-toastr)
// By default vue-notifications can have 4 methods: 'success', 'error', 'info' and 'warn'
// But you can specify whatever methods you want.
// If you won't specify some method here, output would be sent to the browser's console
const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}

// Activate plugin
// VueNotifications have auto install but if we want to specify options we've got to do it manually.
Vue.use(VueNotifications, options)

window.showErrorNotification = function (e) {
    /// <summary>show error message to console and toast.</summary>  
    /// <param name="e" type="exception">Exception</param>  
    var msg = '';
    var headerTitle = 'Eroare';
    var msgType = 'error';
    var msgTimeout = 60000;

    if (e.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (e.response.data != null) {
            console.log(JSON.stringify(e.response.data));
        }

        if (typeof e.response.data.login_failure != 'undefined') {
            msg = e.response.data.login_failure[0];
        } else if (typeof e.response.data.user_locked != 'undefined') {
            msg = e.response.data.user_locked[0];
        } else if (e.response.status == 400) {
            msg = 'A aparut o eroare';
        }

        if (typeof e.response.data.Message != 'undefined')
            msg += ". " + e.response.data.Message;

        if (typeof e.response.data.StackTrace != 'undefined')
            msg += ". " + e.response.data.StackTrace;
    }
    else
        if (e.request) {
            // The request was made but no response was received
            // `e.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(e.request);
        }

    if (msg.length == 0)
        msg = e.message;

    toast({ title: headerTitle, message: msg, type: msgType, timeout: msgTimeout });
};

window.toast = toast;
// END Notifications

// AppInsights
import VueAppInsights from 'vue-application-insights';
Vue.use(VueAppInsights, {
    //id: '6306a4b5-b73e-4a37-bbe1-b807f6fef36d', routes // test
    id: '1604182d-b286-4963-8d12-3b49e529fea5', routes // live
});

// BEGIN Configure router
const router = new VueRouter({
    //mode: 'hash', // https://router.vuejs.org/api/#mode
    scrollBehavior: () => ({ y: 0 }),
    routes, // short for routes: routes
    linkActiveClass: 'open active',
    mode: 'history'
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    //console.log(store.getters['auth/isAuthenticated']);
    if (requiresAuth && !store.getters['auth/isAuthenticated']) {
        next('/crm/pages/login')
    } else {
        next();
    }
});
// END Configure router

// BEGIN Mixins
Vue.mixin({
    //created: function () {
    //    console.log('mixin hook called')
    //},
    methods: {
        getCount: function (items) {
            if (items != null)
                return items.length;
            return 0;
        },

        // Dinamically get the inner object by dotted path.
        getDescendantProp: function (obj, desc) {
            //debugger
            if (desc !== undefined) {
                var arr = desc.split(".");
                while (arr.length && (obj = obj[arr.shift()]));
            }
            return obj;
        },
        // Find the 1st invalid element and focus on it
        findFirstError: function (component = this) {
            
            if (component.state === false) {
                if (component.$refs.input) {
                    component.$refs.input.focus()
                    return true
                }
                if (component.$refs.check) {
                    component.$refs.check.focus()
                    return true
                }
            }
            let focused = false
            component.$children.some((child) => {
                focused = this.findFirstError(child)
                return focused
            })

            return focused;
        },
        formatDate: function (value) {
            // return empty string if null
            if (value == null || value == 'undefined') {
                return '';
            }
            else {
                return (new Date(value)).toLocaleDateString('en-GB');
                //return (new Date(value)).toDateString('dd/MM/yyyy');
            }
        },

        formatDateTime: function (value) {
            // return empty string if null
            if (value == null || value == 'undefined') {
                return '';
            }
            else {

                var date = (new Date(value));
                var returnString = date.toLocaleDateString('en-GB');

                var options = {
                    hour12: false,
                    hour: '2-digit',
                    minute: '2-digit'
                };

                returnString += ' ' + date.toLocaleTimeString('en-GB', options);

                return returnString;

            }
        },

        // Get an item from an array by its Code
        getItemByCode: function (array, itemCode) {
            var result = null;

            if (array == null)
                return result;

            array.map(function (item) {
                if (item && (item.Code == itemCode || item.code == itemCode))
                    result = item;
            });

            return result;
        },

        // Remove item from an array
        removeItem: function (array, itemId) {
            if (array == null)
                return;

            var itemIndex = array.map(function (item) { return item.Id; }).indexOf(itemId);

            if (itemIndex >= 0)
                array.splice(itemIndex, 1);
        },

        // Build an array of code/name objects from a string
        splitText: function (text, sep) {
            var result = [];
            var splittedArray = [];

            if (text != null)
                splittedArray = text.split(sep);

            splittedArray.map(function (value, key) {
                if (value.length > 0)
                    result.push({ code: value, name: value });
            });

            return result;
        },
        // Aggregate a string value from an array of code objects
        buildText: function (array, sep) {
            var result = '';

            array.map(function (value, key) {
                result += value.code + sep;
            });

            return result;
        },
    }
})
// END Mixins

/* eslint-disable no-new */
new Vue({
    el: '#app',
    template: '<App/>',
    store,
    router,
    components: {
        App
    }
})
